import { ResearchModel, DataModel, TeamsModel, PublicationsModel } from '@/models/research/research';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import { sessionService } from '@/providers/services/auth/session';

/**
 * Serializer help to serialize the research API's
 */
export class ResearchSerializer {

    private static INSTANCE = new ResearchSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    /**
     * serializeResearchProjects  help to serialize research projects api data's
     * @param payload
     */
    public serializeResearchProjects(payload: any): ResearchModel[] {
        const results: ResearchModel[] = [];
        const researchList = payload.projects ? payload.projects : [];
        if (researchList.length) {
            researchList.map((research: any) => {
                const projectDetails: ResearchModel = {
                    category: research.category,
                    data: this.serializeData(research.data),
                    description: research.description,
                    id: research.id,
                    publications: this.serializePublications(!research.publications),
                    summary: research.summary,
                    teams: this.serializeTeams(research.teams),
                    title: research.title,
                };
                results.push(projectDetails);
            });
        }
        return results;
    }

    /**
     * serializeData help to serialize data list
     * @param payload
     */
    public serializeData(payload: any) {
        const dataResults: DataModel[] = [];
        if (payload && payload.length) {
            payload.forEach((data: any) => {
            const dataValue: DataModel = {
               name: data.name,
            };
            dataResults.push(dataValue);
            });
        }
        return dataResults;
    }

    /**
     * serializeData help to serialize data list
     * @param payload
     */
    public serializeTeams(payload: any) {
        const teamsResults: TeamsModel[] = [];
        if (payload && payload.length) {
            payload.forEach((team: any) => {
            const cdnUrls = sessionService.getCdnUrl();
            const userCdnUrl = cdnUrls.user_cdn_url;
            const thumbnailUrl = team.thumbnail
             ? (userCdnUrl + team.thumbnail)
             : DEFAULT_IMAGES_PATH.profile;
            const dataValue: TeamsModel = {
               name: team.name,
               thumbnail: thumbnailUrl,
            };
            teamsResults.push(dataValue);
            });
        }
        return teamsResults;
    }

    /**
     * serializePublications help to serialize the publications list
     */
    public serializePublications(payload: any) {
        const publicationsResult: PublicationsModel[] = [];
        if (payload && payload.length) {
            payload.forEach((publicaton: any) => {
                const list: PublicationsModel = {
                    name: publicaton.name,
                    description: publicaton.description,
                    link: publicaton.link,
                    publisherList: publicaton.publisherList,
                };
                publicationsResult.push(list);
            });
        }
        return publicationsResult;
    }
}

export const researchSerializer = ResearchSerializer.instance;
